import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';

export default function Header() {
  const [mobileToggle, setMobileToggle] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className={`header-top-fixed one-page-nav ${scrolled ? 'fixed-header' : ''} ${mobileToggle ? 'menu-open' : ''}`}>
      <div className="container">
        <div className="logo">
          <Link className="navbar-brand" href="#">
            <img className="logo-light" title="Logo" alt="Logo" src="/images/n_logo_new.png" />
          </Link>
        </div>

        <ul className="main-menu">
          {['home', 'about', 'project', 'qualifications', 'hobbies', 'experinces', 'achievments'].map((item) => (
            <li key={item}>
              <ScrollLink
                to={item}
                spy={true}
                smooth={true}
                offset={-80}
                duration={500}
                onClick={() => setMobileToggle(false)}
              >
                {item.charAt(0).toUpperCase() + item.slice(1)}
              </ScrollLink>
            </li>
          ))}
        </ul>

        <div className="d-flex">
          <ScrollLink
            to="contactus"
            spy={true}
            smooth={true}
            offset={-80}
            duration={500}
            onClick={() => setMobileToggle(false)}
            className="px-btn d-none d-lg-inline-flex"
          >
            Let's Talk
          </ScrollLink>
          <button
            className={`toggler-menu d-lg-none ${mobileToggle ? 'open' : ''}`}
            onClick={() => setMobileToggle(!mobileToggle)}
          >
            <span />
          </button>
        </div>
      </div>

      {mobileToggle && <div className="overlay" onClick={() => setMobileToggle(false)} />}
    </div>
  );
}
